import { gql } from '@apollo/client';

export const AUTOPAY_MUTATION = gql`
  mutation ChangeAutoPayEnabledMutation($isAutoPayEnabled: Boolean!) {
    changeAutoPayEnabled(isAutoPayEnabled: $isAutoPayEnabled) {
      ok
    }
  }
`;
